import type { App } from 'vue'

// It is necessary to introduce some components global, such as ElScrollbar, otherwise there are problems with some drop -down items
import { ElLoading, ElScrollbar } from 'element-plus'

const plugins = [ElLoading]

const components = [ElScrollbar]

export const setupElementPlus = (app: App<Element>) => {
  plugins.forEach((plugin) => {
    app.use(plugin)
  })

  // In order to start the environment faster, all styles are introduced in one -time
  if (import.meta.env.VITE_USE_ALL_ELEMENT_PLUS_STYLE === 'true') {
    import('@/styles/index.less')
    return
  }

  components.forEach((component) => {
    app.component(component.name!, component)
  })
}
